module.exports = __webpack_public_path__ + "static/media/Telegram.536a9723.svg";